import React, { useEffect } from 'react'
import { withRouter } from 'react-router'
import GoogleAnalytics from 'react-ga'
import CONFIG from '../config'

GoogleAnalytics.initialize(CONFIG.googleAnalytics.id)

export const trackPage = (page) => {
  GoogleAnalytics.pageview(page)
}

export const withTracking = (WrappedComponent) => {
  const Tracking = (args) => {
    useEffect(() => trackPage(args.location.pathname), [args.location.pathname])

    return <WrappedComponent {...args} />
  }

  return withRouter(Tracking)
}
